// Push an event to the GTM dataLayer
export function sendGTMEvent(event) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

// Standard event helpers
export const analytics = {
  // CTA clicks
  ctaClick: (label, location) =>
    sendGTMEvent({ event: 'cta_click', cta_label: label, cta_location: location }),

  // Demo request
  demoRequest: (source) =>
    sendGTMEvent({ event: 'demo_request', source }),

  // Contact form submit
  // `attribution`: utm_*, gclid, fbclid y referrer de la sesión (INI-145); vacío si no hay.
  contactSubmit: (source, attribution = {}) =>
    sendGTMEvent({ event: 'contact_form_submit', source, ...attribution }),

  // Page engagement
  sectionView: (section) =>
    sendGTMEvent({ event: 'section_view', section_name: section }),

  // Feature interest
  featureClick: (feature) =>
    sendGTMEvent({ event: 'feature_click', feature_name: feature }),

  // Pricing interaction
  planView: (plan) =>
    sendGTMEvent({ event: 'plan_view', plan_name: plan }),

  // Generic custom event
  custom: (event, params = {}) =>
    sendGTMEvent({ event, ...params }),
};
